import AdminWebsocket from './AdminWebsocket';

class NotificationClient extends AdminWebsocket {
	connect() {
		return super.connect('/notifications');
	}

	onStatus(listener) {
		this.onData('status', listener);
	}

	unregisterEventListeners() {
		super.unregisterEventListeners();
		this.onStatus(null);
	}
}

export default NotificationClient;
